import React from 'react';

function Intro() {
  return (
    <section className="intro section-padding position-re">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-6">
            <div className="cont">
              <h4 className="d-slideup wow">
                <span className="sideup-text">
                  <span className="up-text">
                    If you’re looking for a specialist to build a
                  </span>
                </span>
                <span className="sideup-text">
                  <span className="up-text">
                    {' '}
                    meaningful digital project you can easily
                  </span>
                </span>
                <span className="sideup-text">
                  <span className="up-text">
                    {' '}
                    reach us by clicking{' '}
                    <span className="underline">
                      <a href="/dark/page-contact3" className="main-color">
                        here
                      </a>
                    </span>
                  </span>
                </span>
              </h4>
              <div className="exp mt-80 md-mb15">
                <h2 className="fz-70 numb-font">
                  28{' '}
                  <span className="sub-title main-font opacity-7 ml-15">
                    Years of Experience
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="text">
              <p>
                Whether you are a development agency looking to outsource design
                work, a company in search of a Product Designer or Product Team,
                a marketing agency that needs a landing page, a startup that
                wants to launch an app, or an enterprise that plans to rebrand
                or redesign its website, we welcome any challenge with our arms
                wide open.
              </p>
            </div>
            <div className="main-marq o-hidden mt-100">
              <div className="slide-har st1">
                <div className="box">
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>UI-UX Design</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Web Development</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Marketing</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Product</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Branding Design</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                </div>
                <div className="box">
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>UI-UX Design</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Web Development</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Marketing</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Digital Product</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                  <div className="item">
                    <h4 className="d-flex align-items-center">
                      <span>Branding Design</span>
                      <span className="fz-50 ml-50 stroke icon">*</span>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="line-overlay">
        <svg
          viewBox="0 0 1728 1101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M-43 773.821C160.86 662.526 451.312 637.01 610.111 733.104C768.91 829.197 932.595 1062.9 602.782 1098.75C272.969 1134.6 676.888 25.4306 1852 1"
            style={{ strokeDasharray: 3246.53 }}
          ></path>
        </svg>
      </div>
    </section>
  );
}

export default Intro;
